import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  DataType,
  AddProductState,
  getAddProductType,
  SaveProductPayload,
} from '../types/addProduct.types'
const initialState: AddProductState = {
  content: [],
  selected: null,
  totalPages: null,
}

const addProductSlice = createSlice({
  name: 'addProducts',
  initialState: initialState,
  reducers: {
    updateAddProductsByPage: (
      state: AddProductState,
      action: { payload: AddProductState }
    ) => {
      state.content = action.payload.content
      state.totalPages = action.payload.totalPages
    },
    updateAddProductsData: (
      state: AddProductState,
      action: { payload: AddProductState }
    ) => {
      state.content = action.payload.content
    },
    updateSelectedAddProducts: (
      state: AddProductState,
      action: { payload: DataType }
    ) => {
      state.selected = action.payload
    },
    resetSelectedAddProducts: (state) => {
      state.selected = null
    },
    getAllAddProductsAction: () => {
      return
    },
    getSingleAddProductsAction: () => {
      return
    },
    createAddProductsAction: (state: AddProductState, _action) => {
      return state
    },

    updateAddProductsAction: (
      state: AddProductState,
      action: PayloadAction<SaveProductPayload>
    ) => {
      const addProductsData = action.payload.addProductsData
      if (addProductsData) {
        const index = state.content.findIndex(
          (product) => product?.['id'] === addProductsData.id
        )

        if (index !== -1) {
          state.content[index] = { ...state.content[index], ...addProductsData }
        }
      }
    },

    deleteAddProductsAction: () => {
      return
    },
    patchToggleUpdateDisableActionAddProducts: () => {
      return
    },
    patchToggleUpdateEnableActionAddProducts: () => {
      return
    },
    patchToggleUpdateBulkDisableActionAddProducts: () => {
      return
    },
    patchToggleUpdateBulkEnableActionAddProducts: () => {
      return
    },
    getAllAddProductsByPageAction: (state: AddProductState) => {
      return state
    },
    getAddProductsDataBySortAction: (
      state: AddProductState,
      _action: PayloadAction<getAddProductType>
    ) => {
      return state
    },
  },
})

export const {
  updateAddProductsData,
  getAllAddProductsAction,
  getSingleAddProductsAction,
  updateAddProductsAction,
  updateSelectedAddProducts,
  createAddProductsAction,
  resetSelectedAddProducts,
  deleteAddProductsAction,
  patchToggleUpdateDisableActionAddProducts,
  patchToggleUpdateEnableActionAddProducts,
  patchToggleUpdateBulkDisableActionAddProducts,
  patchToggleUpdateBulkEnableActionAddProducts,
  getAllAddProductsByPageAction,
  updateAddProductsByPage,
  getAddProductsDataBySortAction,
} = addProductSlice.actions
export default addProductSlice.reducer
